'use client';

import { useEffect, useRef, useState } from 'react';

import {
  mountBnplBadge,
  MountBnplBadgeOptions
} from '@/fo/api/payment/yandex-pay';

import { styles } from './UiPaymentBnplBadge.styles';

export interface UiPaymentBnplBadgeProps
  extends Omit<MountBnplBadgeOptions, 'element'> {
  className?: string;
}

export function UiPaymentBnplBadge({
  amount,
  size = 'm',
  variant = 'detailed',
  color = 'transparent',
  theme = 'light',
  align = 'left',
  className
}: UiPaymentBnplBadgeProps) {
  const slots = styles();
  const ref = useRef<HTMLDivElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    if (!amount || amount <= 0) return;

    ref.current.innerHTML = '';
    setIsLoaded(false);

    void mountBnplBadge({
      element: ref.current,
      amount,
      size,
      variant,
      color,
      theme,
      align
    }).then(() => {
      setIsLoaded(true);
    });
  }, [amount, size, variant, color, theme, align]);

  return (
    <div
      ref={ref}
      className={slots.base({ className, isLoaded })}
      aria-label="yandex-pay-split-badge"
    />
  );
}

export default UiPaymentBnplBadge;
